var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"label":"Vuetify Version","rules":[_vm.rules.required],"items":_vm.versions,"loading":_vm.loading,"hint":_vm.hint,"dense":"","outlined":"","persistent-hint":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return _c('v-list-item-content',{class:{
      'orange--text text--darken-3': item === _vm.tags.next,
      'green--text': item === _vm.tags.latest
    }},[_c('v-list-item-title',[_vm._v(_vm._s(item))])],1)}}]),model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }